module.exports = __webpack_public_path__ + "static/media/connect.aa0d255c.svg";